import React, { useState, useEffect } from "react";
import axiosInstance from '../../../services/AxiosInstance';

import swal from "sweetalert";


import { Modal, Button, Form } from "react-bootstrap";

const LevelOne = (props) => {
    const [userId, setUserId] = useState('');
    const [levelOnes, setLevelOnes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        date: '',
        wallPushUp: '',
        highPlank: '',
        sitUp: '',
        wallSit: '',

    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("userDetails")).idToken;
        const config = {
            headers: {
                authorization: "Bearer " + token
            }
        };

        // get the userId from the URL parameter
        const { id } = props.match.params;
        setUserId(id);

        // fetch all levelOne data for the user
        const fetchLevelOne = async () => {
            try {
                const response = await axiosInstance.get(`/levelOne/${id}`, config);
                const formattedLevelOnes = response.data.map((levelOne) => ({
                    ...levelOne,
                    date: new Date(levelOne.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })
                }));
                setLevelOnes(formattedLevelOnes);
            } catch (error) {
                console.log(error);
            }
        };
        fetchLevelOne();
    }, []);

    const handleSubmit = async (event) => {
        const { id } = props.match.params;
        event.preventDefault(); // prevent the default form submit behavior

        // prepare the levelOne data to be sent to the server
        const data = {
            date: formData.date,
            wallPushUp: formData.wallPushUp,
            highPlank: formData.highPlank,
            sitUp: formData.sitUp,
            wallSit: formData.wallSit,
        };

        try {
            // send a post request to the server to save the new levelOnes
            const token = JSON.parse(localStorage.getItem("userDetails")).idToken;
            const config = {
                headers: {
                    authorization: "Bearer " + token
                }
            };
            await axiosInstance.post(`/levelOne/${id}`, data, config);

            // clear the form data and close the modal
            setFormData({
                date: '',
                wallPushUp: '',
                highPlank: '',
                sitUp: '',
                wallSit: '',
            });
            setShowModal(false);

            // fetch the updated levelOnes and update the state
            const response = await axiosInstance.get(`/levelOne/${userId}`, config);
            const formattedLevelOnes = response.data.map((levelOne) => ({
                ...levelOne,
                date: new Date(levelOne.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })
            }));
            setLevelOnes(formattedLevelOnes);

            // show a success swal
            swal('Good job!', 'Successfully Added', 'success');

        } catch (error) {
            console.error(error);

            // show a fail swal
            swal({
                title: 'Oops...',
                text: 'Please fill all the fields and try again!',
                icon: 'error',
                buttons: {
                    confirm: "Try Again"
                }
            });
        }
    };



    return (
        <React.Fragment>

            <Button className="btn btn-primary font-w600 mb-2 mr-auto" onClick={handleShowModal}>+ Add New Results Level 1</Button>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>New Results Level 1</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="form-group">

                            <label htmlFor="date">Date:</label>
                            <input
                                type="date"
                                name="date"
                                className="form-control"
                                value={formData.date}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-group">

                            <label htmlFor="height">Wall Push Up/30s:</label>
                            <input
                                type="number"
                                name="wallPushUp"
                                className="form-control"
                                value={formData.wallPushUp}
                                onChange={handleInputChange}
                                required
                            />

                        </div>

                        <div className="form-group ">

                            <label htmlFor="weight">High Plank Max Time (s):</label>
                            <input
                                type="number"
                                name="highPlank"
                                className="form-control"
                                value={formData.highPlank}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="fat">Sit Up/60s:</label>
                            <input
                                type="number"
                                name="sitUp"
                                className="form-control"
                                value={formData.sitUp}
                                onChange={handleInputChange}
                                required
                            />

                        </div>
                        <div className="form-group">

                            <label htmlFor="muscle">Wall Sit Max Time (s):</label>
                            <input
                                type="number"
                                name="wallSit"
                                className="form-control"
                                value={formData.wallSit}
                                onChange={handleInputChange}
                                required
                            />
                        </div>


                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSubmit}>
                        Add  Results
                    </Button>
                </Modal.Footer>
            </Modal>


            <div className="row">
                {levelOnes.map((levelOne) => (
                    <div key={levelOne.id} className="col-xl-4 col-xxl-6 col-lg-6">
                        <div className="card">
                            <div className="card-header bg-primary">
                                <div className="d-flex mr-3 align-items-center">
                                    {/* <i class="fa fa-calendar text-white"></i> */}
                                    <span className="p-3 mr-3 rounded-circle bg-white">
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3 5.99998H5V3.99998C5 3.73478 5.10536 3.48043 5.29289 3.29289C5.48043 3.10536 5.73478 2.99998 6 2.99998C6.26522 2.99998 6.51957 3.10536 6.70711 3.29289C6.89464 3.48043 7 3.73478 7 3.99998V5.99998H17V3.99998C17 3.73478 17.1054 3.48043 17.2929 3.29289C17.4804 3.10536 17.7348 2.99998 18 2.99998C18.2652 2.99998 18.5196 3.10536 18.7071 3.29289C18.8946 3.48043 19 3.73478 19 3.99998V5.99998H21V8.99998H3V5.99998ZM19 9.99998H5V19H19V9.99998ZM7 11H9V13H7V11ZM11 11H13V13H11V11ZM15 11H17V13H15V11ZM7 15H9V17H7V15ZM11 15H13V17H11V15ZM15 15H17V17H15V15Z" fill="#e71f86" />
                                        </svg>
                                    </span>
                                    <h4 className="fs-20 text-white mb-0">{levelOne.date}</h4>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table shadow-hover">

                                        <tbody>
                                            <tr>
                                                <td>
                                                    <p className="text-black mb-1 font-w600">
                                                        Wall Push Up/30s
                                                    </p>
                                                </td>
                                                <td>
                                                    <span className="fs-14">{levelOne.wallPushUp}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p className="text-black mb-1 font-w600">
                                                        High Plank Max Time (s)
                                                    </p>
                                                </td>
                                                <td>
                                                    <span className="fs-14">{levelOne.highPlank}s</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p className="text-black mb-1 font-w600">
                                                        Sit Up/60s
                                                    </p>
                                                </td>
                                                <td>
                                                    <span className="fs-14">{levelOne.sitUp}</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p className="text-black mb-1 font-w600">
                                                        Wall Sit Max Time (s)
                                                    </p>
                                                </td>
                                                <td>
                                                    <span className="fs-14">{levelOne.wallSit}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
};

export default LevelOne;
